/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePlanRequest } from '../../models/change-plan-request';
import { SubscriptionDto } from '../../models/subscription-dto';

export interface BillingSubscriptionChangePlanPost$Plain$Params {
      body?: ChangePlanRequest
}

export function billingSubscriptionChangePlanPost$Plain(http: HttpClient, rootUrl: string, params?: BillingSubscriptionChangePlanPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, billingSubscriptionChangePlanPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionDto>;
    })
  );
}

billingSubscriptionChangePlanPost$Plain.PATH = '/billing/subscription/change-plan';
